import { render, staticRenderFns } from "./MenuLeftPremium.vue?vue&type=template&id=59fb2bd0&scoped=true&"
import script from "./MenuLeftPremium.vue?vue&type=script&lang=js&"
export * from "./MenuLeftPremium.vue?vue&type=script&lang=js&"
import style0 from "./MenuLeftPremium.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MenuLeftPremium.vue?vue&type=style&index=1&id=59fb2bd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fb2bd0",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BNavItem, BNav, BContainer} from 'bootstrap-vue'
    installComponents(component, {BNavItem, BNav, BContainer})
    

export default component.exports